import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listLegalProcessDocumentService } from "../services/listLegalProcessDocument.service";

export const useLegalProcessDocumentQuery = (filters) => {
  const fetchData = useFetch();
  const [documents, setDocments] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchIndicators = async () => {
      try {
        setLoading(true);
        const response = await listLegalProcessDocumentService(fetchData)(
          filters
        );

        setDocments(response.data);
        setTotal(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchIndicators, 500);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters, page]);

  return {
    documents,
    loading,
    refresh: () => setRefresh((prev) => !prev),
    total,
    totalPages,
    page,
    onChangePage: (newPage) => setPage(newPage),
  };
};
